import { motion } from "framer-motion";
import { Star, Award, Car } from "lucide-react";
import { useLang } from "../../site-context";

const EASE = [0.22, 1, 0.36, 1];

export default function Heritage() {
  const { t } = useLang();
  return (
    <section id="historia" className="relative overflow-hidden py-24 lg:py-32" data-testid="heritage-section">
      <div
        className="pointer-events-none absolute left-[-15%] top-1/3 h-[500px] w-[500px] rounded-full bg-[#e3a008]/8 blur-[130px]"
        aria-hidden="true"
      />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE }}
            className="lg:col-span-5"
          >
            <div className="flex items-end gap-4" data-testid="heritage-experience-badge">
              <span className="ff-display text-gold-gradient text-[9rem] font-bold leading-none sm:text-[12rem]">
                50
              </span>
              <span className="ff-display pb-6 text-5xl font-semibold text-[#e3a008] sm:text-6xl">+</span>
            </div>
            <p className="ff-mono mt-2 text-[11px] uppercase tracking-[0.35em] text-slate-400">
              {t.heritage_badge_years}
            </p>

            <div className="mt-10 space-y-4">
              <div
                className="flex items-center gap-4 rounded-2xl border border-[#e3a008]/20 bg-[#12233f]/60 p-5"
                data-testid="google-rating-badge"
              >
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-[#e3a008] text-[#e3a008]" />
                  ))}
                </div>
                <div>
                  <span className="ff-display text-xl font-semibold text-white">5.0</span>
                  <span className="ml-2 text-sm text-slate-400">{t.heritage_badge_rating}</span>
                </div>
              </div>
              <div className="flex items-center gap-4 rounded-2xl border border-[#e3a008]/20 bg-[#12233f]/60 p-5">
                <Car className="h-6 w-6 text-[#e3a008]" strokeWidth={1.75} />
                <span className="text-base font-medium text-white">{t.heritage_badge_fleet}</span>
              </div>
              <div className="flex items-center gap-4 rounded-2xl border border-[#e3a008]/20 bg-[#12233f]/60 p-5">
                <Award className="h-6 w-6 text-[#e3a008]" strokeWidth={1.75} />
                <span className="text-base font-medium text-white">Táxis Leão & Henrique · Lamoso</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="lg:col-span-7"
          >
            <p className="ff-mono mb-4 text-[11px] uppercase tracking-[0.35em] text-[#e3a008] sm:text-xs">
              {t.heritage_eyebrow}
            </p>
            <h2 className="ff-display text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
              {t.heritage_title}
            </h2>
            <p className="mt-6 text-base font-light leading-relaxed text-slate-300 sm:text-lg">{t.heritage_p1}</p>
            <p className="mt-4 text-base font-light leading-relaxed text-slate-400 sm:text-lg">{t.heritage_p2}</p>

            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3, ease: EASE }}
              className="gold-frame mt-10 overflow-hidden rounded-2xl"
            >
              <img
                src="/assets/logo-full.png"
                alt="Logótipo Táxis Leão & Henrique — leão dourado sobre azul-marinho"
                className="w-full object-cover"
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
